import { render, staticRenderFns } from "./DiscountDetail.vue?vue&type=template&id=4800bcce"
import script from "./DiscountDetail.vue?vue&type=script&lang=js"
export * from "./DiscountDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports